import './TestModule.css';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import React from 'react';

const TestModule = ({
	SectionName,
	score,
	totalScore,
	CorrectQuestions,
	TotalQuestions,
	frequentMistakes,
}) => {
	let totalCorrect = 0;
	let sumTotalQuestions = 0;
	const sectionModules = CorrectQuestions[SectionName];
	Object.keys(sectionModules).map((moduleName) => {
		totalCorrect = totalCorrect + sectionModules[moduleName];
		sumTotalQuestions = sumTotalQuestions + TotalQuestions[SectionName][moduleName];
	});
	console.log('score:', score);
	return (
		<div className="test-module-container" key={SectionName}>
			<div className="test-module-container-col1">
				<div className="test-module-name">{SectionName}</div>
				<div className="test-module-score">
					<span className="blue bold">{score}</span> / {totalScore}
				</div>
				<div className="test-module-individual-score">
					<ul>
						{Object.keys(CorrectQuestions[SectionName]).map((moduleName) => {
							const correct = CorrectQuestions[SectionName][moduleName];
							const total = TotalQuestions[SectionName][moduleName];
							return (
								<li key={moduleName}>
									<span className="module-name bold">{moduleName}</span>
									<div className="score-section">
										<span className="blue">{correct}</span>
										<span>/</span>
										<span>{total}</span>
									</div>
								</li>
							);
						})}
					</ul>
				</div>
				<div className="test-module-frequent-mistakes">
					<div className="test-module-frequent-mistakes-header blue">
						Frequent Mistakes:
					</div>
					<div className="test-module-frequent-mistakes-list">
						<ul>
							{frequentMistakes?.map((mistake, index) => (
								<li key={index}>{mistake}</li>
							))}
						</ul>
					</div>
				</div>
			</div>
			<div className="test-module-container-col2">
				<div className="TMcircular-progress-bar">
					<CircularProgressbar
						value={(totalCorrect / sumTotalQuestions) * 100}
						text={`${totalCorrect}/${sumTotalQuestions}`}
						strokeWidth={10}
						styles={buildStyles({
							pathColor: '#1F21E6',
							textColor: 'black',
						})}
					/>
				</div>
			</div>
		</div>
	);
};

export default TestModule;
